import { render } from "./QualityDashboard.vue?vue&type=template&id=49eadae6&scoped=true"
import script from "./QualityDashboard.vue?vue&type=script&lang=js"
export * from "./QualityDashboard.vue?vue&type=script&lang=js"

import "./QualityDashboard.vue?vue&type=style&index=0&id=49eadae6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49eadae6"]])

export default __exports__
import QBtnGroup from 'quasar/src/components/btn-group/QBtnGroup.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QBtnGroup,QBtn});
